import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MdAirplanemodeActive } from "react-icons/md";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { cn } from "../../../utils/classnames";
import { createTypographyHelper } from "../../../utils/typography";
import { getPageContents } from "../../../actions/admin/cmspage";
import {
  BusinessCenterIcon,
  LocalActivityIcon,
} from "../../../components/icons";
import { BookSection } from "../../../components/book-section/BookSection";
import { AirportTransfer } from "./components/AirportTranfer";
import { PrivateTour } from "./components/PrivateTour";
import { ExecutiveTransfer } from "./components/ExecutiveTransfer";
import { WhyChooseTaxiSection } from "./components/WhyChooseTaxiSection";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ServiceBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/service-banner.png";
const ServicesPage = () => {
  const page_name = "cms-index";
  const [activeTab, setActiveTab] = useState("AirportTransfer");
  const cmspage_state = useSelector((state) => state.cmspage);
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  const { location, push } = useHistory();
  const search = new URLSearchParams(location.search);

  const dispatch = useDispatch();

  const tabList = [
    {
      id: "AirportTransfer",
      icon: (active) => (
        <MdAirplanemodeActive
          color={active ? "#4E4E4E" : "#8D8D8D"}
          size={20}
        />
      ),
    },
    {
      id: "ExecutiveTransfer",
      icon: (active) => (
        <BusinessCenterIcon color={active ? "#4E4E4E" : "#8D8D8D"} size={20} />
      ),
    },
    {
      id: "PrivateTour",
      icon: (active) => (
        <LocalActivityIcon color={active ? "#4E4E4E" : "#8D8D8D"} size={20} />
      ),
    },
  ];

  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);

  useEffect(() => {
    const type = search.get("type");
    if (type) {
      const selectedTab = tabList.find((tab) => tab.id === type);
      if (selectedTab) {
        setActiveTab(selectedTab.id);
      }
    }
  }, [location.search]);

  return (
    <FrontLayout>
      <div className="tw:relative tw:max-w-[1920px] tw:!mx-auto">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0"></div>
          <img
            src={ServiceBanner}
            alt="Alphard banner"
            className="tw:w-full tw:h-[430px] tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t("Services")}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t(`Service.${activeTab}.Title`)}
            </div>
          </div>
        </div>
        <div className="tw:bg-[#F9F9F9] tw:relative tw:border-b tw:border-b-[#8D8D8D] tw:h-[72px] tw:lg:h-[100px]">
          <div className="tw:flex tw:lg:justify-between tw:px-3 tw:lg:px-[82px] tw:pt-3 tw:lg:pt-[27px] tw:overflow-x-auto tw:whitespace-nowrap tw:absolute tw:w-full">
            {tabList.map((tab) => (
              <div
                className={cn(
                  "tw:flex-1 tw:text-center tw:flex-shrink-0 tw:h-[60px] tw:lg:h-[73px] tw:px-5 tw:flex tw:items-center tw:justify-center tw:font-hanken-grotesk tw:font-normal tw:lg:font-medium tw:space-x-2 tw:lg:space-x-3",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg"),
                  activeTab === tab.id
                    ? "tw:bg-white tw:border-x tw:border-x-[#8D8D8D] tw:border-t tw:border-t-[#8D8D8D] tw:text-[#282828] tw:rounded-tl-md tw:rounded-tr-md"
                    : "tw:text-[#8D8D8D] tw:cursor-pointer"
                )}
                onClick={() => push(`?type=${tab.id}`)}
                key={tab.id}
              >
                {tab.icon(activeTab === tab.id)}
                <div>{t(`Service.${tab.id}.Title`)}</div>
              </div>
            ))}
          </div>
        </div>
        {activeTab === "AirportTransfer" && <AirportTransfer />}
        {activeTab === "ExecutiveTransfer" && <ExecutiveTransfer />}
        {activeTab === "PrivateTour" && <PrivateTour />}
        <WhyChooseTaxiSection />
        <BookSection />
      </div>
    </FrontLayout>
  );
};

export default ServicesPage;
